import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActionsModule} from "./actions/actions.module";
import {InterventionTeamsModule} from "./intervention-teams/intervention-teams.module";


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ActionsModule,
    InterventionTeamsModule,
  ]
})
export class MaintenanceModule {
}
